import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import {
  DonationPlan,
  PlanId,
} from 'features/src/lib/donations/types/donation-plans';

@Component({
    selector: 'lib-donation-type-toggle',
    imports: [CommonModule, TranslateModule],
    templateUrl: './donation-type-toggle.component.html',
    styleUrls: ['./donation-type-toggle.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DonationTypeToggleComponent),
            multi: true,
        },
    ]
})
export class DonationTypeToggleComponent implements ControlValueAccessor {
  @Input() plans: DonationPlan[] = [];
  /** Opcional: deshabilitar planes no permitidos (p. ej. cuando no se acepta recurring) */
  @Input() disabledPlanIds: PlanId[] = [];

  value: PlanId | null = null;
  disabled = false;

  private onChange: (value: PlanId | null) => void = () => {};
  private onTouched: () => void = () => {};

  select(id: PlanId) {
    if (this.disabled || this.disabledPlanIds.includes(id)) return;
    this.value = id;
    this.onChange(id);
    this.onTouched();
  }

  // CVA
  writeValue(v: PlanId | null): void {
    this.value = v;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
